import React, { useEffect, useState } from 'react'
import Footer from './Footer'
import Menu from './Menu'
import FormPopup from './FormPopup'
import useGadSource from '../utils/useGadSource'
// import PrivacyPopup from './PrivacyPopup'
import Announcement from './Announcement'
// import sha256 from 'sha256'

// const PASSWORD =
//   '39d0ab282ba2d567847d956a7dc3cde5726477acb35f11dd10de9e67c7b4c2ed' //8ZQMtgM08Kx4

const Layout = ({ children, white }) => {
  const gadSource = useGadSource()

  // const [access, setAccess] = useState(false)
  // const [password, setPassword] = useState('')

  // const onChange = (event) => {
  //   event.preventDefault()
  //   const newPassword = event.target.value

  //   if (sha256(newPassword) === PASSWORD) {
  //     setAccess(true)
  //     localStorage.setItem('password', newPassword)
  //   }
  //   setPassword(newPassword)
  // }

  // useEffect(() => {
  //   const savedPassword = localStorage.getItem('password')
  //   if (savedPassword && sha256(savedPassword) === PASSWORD) setAccess(true)
  // }, [])

  // if (!access)
  //   return (
  //     <>
  //       <div
  //         css={{
            
  //           display: 'flex',
  //           justifyContent: 'center',
  //           alignItems: 'center',
  //           width: '100vw',
  //           height: '100vh',
  //         }}
  //       >
  //         <input type='password' value={password} onChange={onChange} />
  //       </div>
  //     </>
  //   )

  return (
    <>
      <Menu white={white} />
      <main>{children}</main>
      <Footer />
      <FormPopup />
      {/* <PrivacyPopup /> */}
      <Announcement />
    </>
  )
}

export default Layout
